import http from '../utils/fetch'


export default {
  activate (code) {
    return http.put({
      url: `v1/coupon/${code}/activate`,
    })
  },
  list () {
    return http.get({
      url: `v1/coupon`,
    })
  },
  acitveList () {
    return http.get({
      url: `v1/coupon/active`,
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/coupon.js